import { parseDataTransform } from '@acme/common'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { useAuth } from 'hooks'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { AfastamentoV2, afastamentoV2, ocorrencia } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { useUpdateDigitacaoQueryData } from 'templates/ManutencaoDoPonto/Digitacao/pages/useDigitacaoData'

/** Código fixo da ocorrência de DSR — o mesmo que a API usa para resolver o DSR do cliente. */
const CODIGO_OCORRENCIA_DSR = 8989

export default function NovoDSR() {
    const { dia } = useParams()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const navigate = useNavigate()

    if (!dia) navigate(-1)

    const { data: ocorrencias, isFetched } = ocorrencia.useFetch()
    const { mutateAsync } = afastamentoV2.mutations.useCreate()
    const {
        decoded: { categoria },
    } = useAuth()
    const ocorrenciaId = ocorrencias?.find(
        ({ codigo }) => codigo === CODIGO_OCORRENCIA_DSR,
    )?.id
    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<any> = async () => {
        if (!ocorrenciaId) return toast.error('Ocorrência não cadastrada.')

        await mutateAsync(
            {
                ...parseDataTransform({
                    dataInicial: dia,
                    dataFinal: dia,
                }),
                ocorrenciaId,
                funcionarios: [funcionarioId],
                empresaId,
                origem: [3, 4, 6].includes(categoria) ? 1 : 2,
            } as unknown as AfastamentoV2,
            {
                onSuccess: payload => {
                    if ('dataInicial' in payload[0])
                        setQueryData('AFASTAMENTO', payload[0])
                    toast.success('DSR cadastrado com sucesso.')
                },
                onError: e => {
                    toast.error(e.message)
                },
            },
        )
    }

    return (
        <Dialog.Root onSubmit={handleSubmit}>
            <Dialog.Title>Descanso semanal remunerado</Dialog.Title>
            <Dialog.Content>
                Deseja realizar o DSR para o dia{' '}
                {dayjs(dia).format('DD/MM/YYYY')}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton
                    closeOnSubmit
                    disabled={!isFetched}
                >
                    Sim
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
